import React from "react";

export const BrandOne = () => {
  return (
    <div className="brand-aera pb-100">
      <div className="container">
        <div className="row brand-active">
          {/* Brand list and slider removed due to unused warnings */}
        </div>
      </div>
    </div>
  );
};
